export enum Tenant {
    INTERCOM = 'intercom',
}
